module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm_03"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Crush")])]), _vm._v(" "), _c('p', {
    staticClass: "title1"
  }, [_vm._v("AN EROTIC NOVEL")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_vm._v("Cécile de La Baume")]), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("TRANSLATED FROM THE FRENCH BY")]), _vm._v(" "), _c('p', {
    staticClass: "title4"
  }, [_vm._v("RAMONA DESFLEURS")]), _vm._v(" "), _c('p', {
    staticClass: "title4a"
  }, [_c('img', {
    staticClass: "imgepub",
    attrs: {
      "alt": "",
      "src": "images/img_0001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title5"
  }, [_vm._v("GROVE PRESS")]), _vm._v(" "), _c('p', {
    staticClass: "title6"
  }, [_c('span', [_vm._v("New York")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb7c5694","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Title.vue
// module id = 69
// module chunks = 0